import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setHeaderLoaded } from "../../store/store";
import "./Header.scss";
import HeaderLeft from "./HeaderLeft/HeaderLeft";
import HeaderRight from "./HeaderRight/HeaderRight";
import HeaderMenu from "./HeaderMenu/HeaderMenu";
import Wrapper from "../Common/Wrapper";
import { useGetThemeOptionsQuery, useGetMenuQuery } from "../../services/themeApi";

const Header = () => {
    const dispatch = useDispatch();

    // Pobieranie danych z API
    const { data: themeOptions, isLoading: isThemeLoading, isError: isThemeError } = useGetThemeOptionsQuery();
    const { data: menuData, isLoading: isMenuLoading, isError: isMenuError } = useGetMenuQuery("main-menu");

    const homeUrl = window.themeSettings?.homeUrl || "/";

    useEffect(() => {
        if (!isThemeLoading && !isMenuLoading && !isThemeError && !isMenuError) {
            dispatch(setHeaderLoaded());
        }
    }, [isThemeLoading, isMenuLoading, isThemeError, isMenuError, dispatch]);

    // Pokaż loader globalny (kontrolowany przez Redux)
    if (isThemeLoading || isMenuLoading || isThemeError || isMenuError) {
        return null;
    }

    return (
        <Wrapper>
            <div className="header--inside">
                {themeOptions && menuData && (
                    <>
                        <HeaderLeft
                            logo={themeOptions.header_logo}
                            homeUrl={homeUrl}
                        />
                        <HeaderRight
                            buttonText={themeOptions.header_button_text}
                            buttonUrl={themeOptions.header_button_url}
                            menuData={menuData}
                        />
                    </>
                )}
            </div>
        </Wrapper>
    );
};

export default Header;
